import { Box, Container, Typography } from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';
import { useContext } from "react";
import MobileContext from "../../context/MobileContext";
import { TypographyVariant } from "@mui/material";

const Footer = () => {
    const mobile = useContext(MobileContext);
    const variantToDisplay: TypographyVariant = mobile ? "body1" :"h6";
    return <Box sx={{
        width: '100%'
    }}>
        <Box sx={{width: '100%', backgroundColor: '#fbbc04', display: 'flex', alignItems: 'center', justifyContent: 'space-around'}} id="extra-info">
            <Typography variant="subtitle2"><b>PSKC</b></Typography>
            <Typography variant="subtitle2"><b>CUSTOM CLASS II</b></Typography>
            <Typography variant="subtitle2"><b>FILOSOFI KEPABEANAN</b></Typography>
        </Box>
        <Box sx={{backgroundColor: '#042c6c', paddingTop: '1rem'}} id="main-footer">
            <Container>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'left', marginBottom: '1rem'}} id="logo-caption">
                    <img src="/img/main_logo_white_bg.JPG" alt="logo" style={{height: '5rem', marginRight: '1rem', borderRadius: '1rem'}}></img>
                    <Box sx={{display: 'block'}} id="instansi">
                        <Typography variant={variantToDisplay} color='white' sx={{lineHeight: 1, fontWeight: 600}}>
                            POLITEKNIK KEUANGAN NEGARA STAN
                        </Typography>
                        <Typography variant={variantToDisplay} color='white'sx={{lineHeight: 1, fontWeight: 600}}>
                            PUSAT STUDI KEPABEANAN DAN CUKAI
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{display: 'flex', alignItems: 'top', justifyContent: 'space-between'}} id="logo-caption">
                    <Box sx={{color: 'white', display: 'block'}}>
                        <Typography variant="subtitle2" sx={{lineHeight: 1.2}}>POLITEKNIK KEUANGAN NEGARA STAN</Typography>
                        <Typography variant="subtitle2" sx={{lineHeight: 1.2}}>Email : ormawa.pskc@pknstan.ac.id</Typography>
                    </Box>
                    <Box sx={{color: 'white', display: 'block'}}>
                        <Typography variant="subtitle2" sx={{lineHeight: 1.2, fontWeight: 600}}>IKUTI KAMI</Typography>
                        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'right', gap: '0.3rem'}}>
                            <InstagramIcon sx={{cursor: 'pointer'}}/>
                            <a href="https://www.instagram.com/pskc_pknstan/" target="_blank" rel="noreferrer" style={{textDecoration: 'none', color: 'white'}}>
                                <Typography variant="subtitle1">pskc_pknstan</Typography>
                            </a>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{textAlign: 'center', display: 'block', color: 'white', marginTop: '1rem'}}>
                    <Typography variant="caption">Copyright &copy; HPD PSKC</Typography>
                </Box>
            </Container>
        </Box>
    </Box>
};

export default Footer;